import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import AvatarChanger from './AvatarChanger';
import ChangePassword from './ChangePassword';

const Profile = (props) => {

    useEffect(() => {
        //onload execute ....
    }, []);

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Mi Perfil</h1>
                        <span className="upper">Información de mi perfil</span>
                    </div>
                    <div className="flexWrapper"> 
                        <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                    </div>
                </div>

                <h3>Cambio de imagen de perfil</h3>
                <AvatarChanger/>

                <br /><hr className='sep' />

                <ChangePassword/>
            </div>
        </div>    
    );
    
}

export default Profile;
